import script from "./UserPaymentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPaymentDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserPaymentDialog.vue?vue&type=style&index=0&id=01fe8d0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01fe8d0e"]])

export default __exports__